var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBudgetWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.91797,
    y: 1.5,
    width: 18,
    height: 20.25,
    rx: 5.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 4.5C17.0815 4.5 17.4243 4.83806 17.3556 5.24654C17.2994 5.58046 17.2056 5.90776 17.0754 6.22208C16.8493 6.76804 16.5178 7.26412 16.0999 7.68198C15.6821 8.09984 15.186 8.43131 14.64 8.65746C14.0941 8.8836 13.5089 9 12.918 9C12.327 9 11.7419 8.8836 11.1959 8.65746C10.6499 8.43131 10.1539 8.09984 9.73599 7.68198C9.31812 7.26412 8.98666 6.76804 8.76051 6.22207C8.63032 5.90776 8.5365 5.58046 8.48032 5.24654C8.41161 4.83806 8.75447 4.5 9.16869 4.5C9.5829 4.5 9.91018 4.84088 10.0127 5.24221C10.0479 5.38004 10.093 5.51549 10.1477 5.6475C10.2983 6.0113 10.5192 6.34186 10.7977 6.62031C11.0761 6.89875 11.4067 7.11962 11.7705 7.27031C12.1343 7.42101 12.5242 7.49857 12.918 7.49857C13.3117 7.49857 13.7017 7.42101 14.0655 7.27031C14.4293 7.11962 14.7598 6.89875 15.0383 6.62031C15.3167 6.34186 15.5376 6.0113 15.6883 5.6475C15.743 5.51549 15.788 5.38004 15.8232 5.24221C15.9258 4.84088 16.253 4.5 16.6673 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetWhite);
export default __webpack_public_path__ + "static/media/budget-white.3bddbb56b6f042102ccd56bb110aea6d.svg";
export { ForwardRef as ReactComponent };